export const monthName: {
  [key: string]: {
    short: string;
  };
} = {
  '01': {
    short: 'JAN',
  },
  '02': {
    short: 'FEV',
  },
  '03': {
    short: 'MAR',
  },
  '04': {
    short: 'ABR',
  },
  '05': {
    short: 'MAI',
  },
  '06': {
    short: 'JUN',
  },
  '07': {
    short: 'JUL',
  },
  '08': {
    short: 'AGO',
  },
  '09': {
    short: 'SET',
  },
  '10': {
    short: 'OUT',
  },
  '11': {
    short: 'NOV',
  },
  '12': {
    short: 'DEZ',
  },
};

export const weekdayName: {
  [key: string]: {
    complete: string;
    full: string;
    short: string;
  };
} = {
  sunday: {
    complete: 'Domingo',
    full: 'Domingo',
    short: 'Dom',
  },
  monday: {
    complete: 'Segunda feira',
    full: 'Segunda',
    short: 'Seg',
  },
  tuesday: {
    complete: 'Terça feira',
    full: 'Terça',
    short: 'Ter',
  },
  wednesday: {
    complete: 'Quarta feira',
    full: 'Quarta',
    short: 'Qua',
  },
  thursday: {
    complete: 'Quinta feira',
    full: 'Quinta',
    short: 'Qui',
  },
  friday: {
    complete: 'Sexta feira',
    full: 'Sexta',
    short: 'Sex',
  },
  saturday: {
    complete: 'Sábado',
    full: 'Sábado',
    short: 'Sáb',
  },
};
